import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { formatRecords } from '@/utils'

// config
const airtableOptions = { view: 'API Display' }

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    exhibitions: null,
    bibliography: null,
    press: null,
    faq: null,
    blogchain: null
  },
  mutations: {
    setExhibitions (state, records) {
      state.exhibitions = records
    },
    setBibliography (state, records) {
      state.bibliography = records
    },
    setPress (state, records) {
      state.press = records
    },
    setFAQ (state, records) {
      state.faq = records
    },
    setBlogchain (state, records) {
      state.blogchain = records
    }
  },
  actions: {
    getAirtable (context, data) {
      /**
      * Generic function for getting all records of a table
      *
      * Note: '/api/table' path is a proxy for the Netlify Function, configured in:
      * – vue.config.js (dev)
      * – public/_redirects (deployed Netlify site)
      * @returns {array} records of the table (default is ALL)
      **/
      return axios.post('/api/table', data)
        .then(response => response.data)
        .catch(err => console.error(err.response))
    },
    getChannel (context, data) {
      /**
      * Generic function to get contents of an Are.na channel (public or private)
      *
      * Queries our Netlify Function (src/netlify-functionsarena__get-channel.js)
      * '/api/channel' path is a proxy for the Netlify Function, mapped in:
      * – vue.config.js (dev)
      * – public/_redirects (deployed Netlify site)
      *
      * Note: Subchannels' contents are empty, must make separate request for each channel.
      *
      * @param {object} data - Channel ID/slug, arena-js parameters (optional)
      * // {id: 'ests', params: {per:100}}
      *
      * @returns {array} blocks of channel
      **/
      return axios.post('/api/channel', data)
        .then(resp => resp.data)
        .catch(err => console.error('Are.na API Error', err.response.data))
    },
    getExhibitions ({ commit, dispatch }) {
      dispatch('getAirtable', { name: 'Exhibitions', options: airtableOptions })
        .then(records => commit('setExhibitions', formatRecords(records)))
    },
    getBibliography ({ commit, dispatch }) {
      dispatch('getAirtable', { name: 'Bibliography', options: airtableOptions })
        .then(records => commit('setBibliography', formatRecords(records)))
    },
    getPress ({ commit, dispatch }) {
      dispatch('getAirtable', { name: 'Press', options: airtableOptions })
        .then(records => commit('setPress', formatRecords(records)))
    },
    getFAQ ({ commit, dispatch }) {
      dispatch('getAirtable', { name: 'FAQ', options: airtableOptions })
        .then(records => commit('setFAQ', formatRecords(records)))
    },
    getBlogchain ({ commit, dispatch }) {
      dispatch('getAirtable', { name: 'Blogchain', options: airtableOptions })
        .then(records => commit('setBlogchain', formatRecords(records)))
    }
  }
})
